import React from 'react';

import { QuestionMarkSvg } from '../../common/svg';

import '../../../styles/shop/shirt-sizes-control.scss';

const ShirtSizesControl = props => {
  const sizes = [
    { size: 'S', label: 'Small' },
    { size: 'M', label: 'Medium' },
    { size: 'L', label: 'Large' },
    { size: 'XL', label: 'X-Large' },
  ];

  return (
    <>
      <span className="product-view__meta-label">
        Size{' '}
        <button
          className="icon-link"
          onClick={() => props.showModalWithContent(
            <>
              <p className="header">Size Chart</p>
              <table className="body-text">
                <tr>
                  <th>Size</th>
                  <th>Chest</th>
                  <th>Waist</th>
                </tr>
                <tr>
                  <td>S</td>
                  <td>34 - 36</td>
                  <td>30 - 32</td>
                </tr>
                <tr>
                  <td>M</td>
                  <td>38 - 40</td>
                  <td>32 - 33</td>
                </tr>
                <tr>
                  <td>L</td>
                  <td>42 - 44</td>
                  <td>33 - 34</td>
                </tr>
                <tr>
                  <td>XL</td>
                  <td>46 - 48</td>
                  <td>36 - 38</td>
                </tr>
              </table>
              <p className="body-text">
                In inches.
              </p>
              <p className="body-text">
                Sizing Tip: Style runs a little small, so you may want to consider sizing up.
              </p>
            </>
          )}
        >
          { QuestionMarkSvg }
        </button>
      </span>
      <div className="shirt-sizes__container">
        {sizes.map(size => (
          <button
            className={`shirt-sizes__option ${(props.size === size.size) ? 'selected' : ''}`}
            onClick={() => props.onChange(size.size)}
          >
            <div className="shirt-sizes__label">{size.label}</div>
          </button>
        ))}
      </div>
    </>
  );
}

export default ShirtSizesControl;